import { render, staticRenderFns } from "./PageValidate.vue?vue&type=template&id=27ab8d95&scoped=true"
import script from "./PageValidate.vue?vue&type=script&lang=js"
export * from "./PageValidate.vue?vue&type=script&lang=js"
import style0 from "./PageValidate.vue?vue&type=style&index=0&id=27ab8d95&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ab8d95",
  null
  
)

export default component.exports